import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { LinkToRunner } from '@eggplant/routing'
import { schedule } from '../../docs-routes'

const ScheduleManagement = () =>
  <Paragraph>
    <Color
      display='inline'
      variant='theme-description-text'
    >
      Use the Schedule Management to view all scheduled runs in calendar view.
      <br />
      <br />
      Before you can use the Schedule Management, you must have at least one scheduled record in <LinkToRunner>Runner</LinkToRunner>.
    </Color>
    <DocusaurusFooter path={schedule} />
  </Paragraph>

export default ScheduleManagement
